// WordPress dependencies.
import { registerBlockStyle } from '@wordpress/blocks';
import domReady from '@wordpress/dom-ready';
import { __ } from '@wordpress/i18n';

domReady( () => {
	registerBlockStyle( 'core/heading', [
		{
			name: 'default',
			label: __( 'Default', 'theme-slug' ),
			isDefault: true,
		},
		{
			name: 'primary',
			label: __( 'Primary', 'theme-slug' ),
		},
		{
			name: 'secondary',
			label: __( 'Secondary', 'theme-slug' ),
		},
	] );

	registerBlockStyle( 'core/button', [
		{
			name: 'small-primary',
			label: __( 'Small Primary', 'theme-slug' ),
		},
		{
			name: 'medium-primary',
			label: __( 'Medium Primary', 'theme-slug' ),
		},
		{
			name: 'small-secondary',
			label: __( 'Small Secondary', 'theme-slug' ),
		},
		{
			name: 'medium-secondary',
			label: __( 'Medium Secondary', 'theme-slug' ),
		},
	] );
	registerBlockStyle( 'core/group', [
		{
			name: 'round-bullet',
			label: __( 'Round Bullet', 'theme-slug' ),
		},
	] );
} );
